<div class="all-page-combo-layout">
  <div class="all-page-feed">
    <div class="hpanel">
      <div class="comNavBar panel-body border-radius-top-left-right-6">
        <div class="navIteam">
          <h6 class="fw-bold" for="">Member<span *ngIf="pesponseDisplay?.memberCnt>1">s </span> :<span>
              {{pesponseDisplay?.memberCnt}} </span></h6>
        </div>
        <div class="navIteam pos-rel-10">
          <input #membersDataText type="text" (input)="onSearchMember(membersDataText.value)"
            class="form-control pd-lt-10 search-field-pad" placeholder="Search Member"
            aria-label="Amount (to the nearest dollar)" name="searchadmin" id="searchadmin" [(ngModel)]="searchKey"
            style="z-index: 1;" />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
        <div class="navIteam">
          <div class="btn-group" dropdown container="body">
            <button id="button-basic" dropdownToggle type="button" class="btn btn-primary"
              aria-controls="dropdown-basic">
              All
              <ng-icon name="tablerFilter"></ng-icon>
            </button>

          </div>
        </div>
        <div class="navIteam">
          <button type="submit" *ngIf="ownerFlag" class="btn primary-btn f-l" (click)="addmember(basicTemplate)">
            Add Member <span class="iuiy" style="left: 0.2rem !important;">
              <!-- <ng-icon name="tablerUserPlus" class="font-15"></ng-icon> -->
            </span> </button>
        </div>
      </div>
    </div>
    <div class="margin-top-5">
      <ng-container *ngIf="loadAPIcall && !loadScroll">
        <div class="col-md-4 padding-left-0 padding-right-5" *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>

      <div class="invite-body" *ngIf="(membersList | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
        [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">

        <div class="col-md-4 padding-left-0 padding-right-5" *ngFor="let data of (membersList | async) ">
          <app-user-card [userDataInput]="data" [labelName]="'NETWORK'" (handleEvent)="handleUserCardEvent($event)"
            [config]="userCardConfig" [button]="'PRIMARY'" [standard]="true"></app-user-card>
        </div>
        <ng-container *ngIf="loadScroll">
          <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5" *ngFor="let n of [1, 2, 3]">
            <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
          </div>
        </ng-container>

        <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (membersList | async)?.length > 0"
          style="text-align: center;padding-top: 1rem;">
          <div class="col-sm-12">
            <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>

          </div>
          <div class="col-sm-12">
            <p class="fontchange">You've reached the bottom of the page</p>
          </div>
        </div>
      </div>

      <div class="col-md-12 pad" *ngIf="(membersList | async)?.length === 0  && !loadAPIcall">
        <app-nodata-found [title]="noDatafound"></app-nodata-found>
      </div>

      <div appQueryDOM [netWorkName]="networkName" class="col-md-12 pad" *ngIf="membersData?.length==0">
        <span class="empty-message" style="font-weight: 700;">Fetching Members</span>
      </div>
    </div>
  </div>
  <div class="all-page-widget">
    <app-common-widget [page]="'NETWORK_MEMBER_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
  </div>
</div>


<ng-template #basicTemplate>
  <form [formGroup]="membersForm" class="app-form form-horizontal">

    <div class="common-header-flex">
      <div>Add Members</div>
      <button>
        <span class="common-close" (click)="modalRef.hide()">&times;</span>
      </button>
    </div>

    <div class="panel-body">

      <div class="form-group row ">

        <div class="col-md-4" style="display: grid;">
          <label for="networkName" class=" control-label required-field font-light">Connected
            User</label>
        </div>

        <div class="col-md-8">
          <ng-select class="gs-conn-select" [items]="conditionList" [hideSelected]="false" dropdownPosition="bottom" [closeOnSelect]="false"
            formControlName="addconnection" bindLabel="userName" [multiple]="true" placeholder="Add Connection"
            [(ngModel)]="conditionSelectedItems">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="ng-select-checkbox-label">
                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                <img *ngIf="item.photo" class="img-show-hides" src="{{url+item.photo}}" style="margin-left: 8px;">
                <div *ngIf="!item?.photo" style="margin-left: 8px;">
                  <div class="circleimg-show-hide"
                    [style.background-color]="getColorName(item?.firstName,item.lastName)">
                    <div style="padding-top:0px;" class="circle-text"
                      [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                      getInitialName(item?.firstName,item.lastName)
                      }}</div>
                  </div>
                </div>
                <span class="ng-select-checkbox-text" [attr.title]="item.userName">{{item.userName}}</span>
              </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
              <div class="selected-item" [attr.title]="item.userName">
                <span class="ng-value-clear remove-icon" (click)="clear(item)">
                  ✕
                </span>
                <span class="ng-value-label">{{ item.userName }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button type="button" class="btn btn-default canbtn" (click)="modalRef.hide()">Cancel</button>
          <button type="button" class="btn primary-btn subbtn" (click)="submit()">Submit</button>
        </div>
      </div>
    </div>

  </form>
</ng-template>